import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a4151d92&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a4151d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4151d92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4151d92')) {
      api.createRecord('a4151d92', component.options)
    } else {
      api.reload('a4151d92', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a4151d92&scoped=true&", function () {
      api.rerender('a4151d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a7wQ6dhbMo6h/JS/comp/Voucher.vue"
export default component.exports